// Kleuren per status van een SES-melding (één bron voor lijst, dialoog en logboek)
export const STATUS_STYLE = {
  incomplete: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-900",
  ready: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950/50 dark:text-sky-300 dark:border-sky-900",
  sending: "bg-sky-100 text-sky-800 border-sky-200 animate-pulse",
  received: "bg-indigo-100 text-indigo-800 border-indigo-200 dark:bg-indigo-950/50 dark:text-indigo-300 dark:border-indigo-900",
  processing: "bg-indigo-100 text-indigo-800 border-indigo-200 dark:bg-indigo-950/50 dark:text-indigo-300 dark:border-indigo-900",
  accepted: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/50 dark:text-emerald-300 dark:border-emerald-900",
  rejected: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950/50 dark:text-red-300 dark:border-red-900",
  uncertain: "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-950/50 dark:text-orange-300 dark:border-orange-900",
  cancel_requested: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
  cancelled: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
  withdrawn: "bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700",
};

export const KIND_STYLE = {
  PV: "bg-emerald-600 text-white",
  RH: "bg-sky-600 text-white",
  B: "bg-slate-600 text-white",
};

export const EDITABLE = ["incomplete", "ready", "rejected"];

export function StatusBadge({ status, t }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold tracking-wide ${STATUS_STYLE[status] || "bg-muted text-foreground"}`}
      data-testid={`ses-status-${status}`}>
      {t(`ses_st_${status}`)}
    </span>
  );
}

export function KindBadge({ kind }) {
  return <span className={`inline-flex items-center justify-center rounded-md px-2 py-0.5 font-mono text-[11px] font-bold ${KIND_STYLE[kind] || "bg-muted"}`}>{kind}</span>;
}

export function ModeBadge({ mode, t }) {
  const live = mode === "live";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-bold tracking-[0.14em] ${live ? "bg-red-600 text-white" : "bg-amber-400 text-amber-950"}`}
      data-testid="ses-mode-badge">
      <span className={`h-1.5 w-1.5 rounded-full ${live ? "bg-white animate-pulse" : "bg-amber-900"}`} />
      {live ? t("ses_mode_badge_live") : t("ses_mode_badge_test")}
    </span>
  );
}

export const fmt = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" }) : "—");
